import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, XCircle } from 'lucide-react';
import { PendingPaymentBanner } from '../../components/portal/PendingPaymentBanner';

/**
 * Il Cliente ha lasciato la cassa Nexi (`url_back`).
 *
 * Questa rotta non è firmata e non decide nulla: l'ordine resta in attesa
 * finché la riconciliazione non lo chiude, o finché il Cliente non riprende
 * lo stesso pagamento tornando al checkout. Per questo il testo dice "non
 * completato" e non "annullato" — annullarlo non l'ha ancora fatto nessuno.
 */
export default function PaymentCancelledPage() {
  const [params] = useSearchParams();
  const codTrans = params.get('codTrans') || '';

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-12" data-testid="payment-cancelled-page">
      <div className="rounded-xl border bg-white p-8 text-center">
        <XCircle className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-xl font-semibold mb-2">Pagamento non completato</h1>
        <p className="text-sm text-muted-foreground mb-1">
          Hai lasciato la pagina di pagamento. <strong>Nessun importo è stato addebitato</strong> e
          il carrello è ancora a tua disposizione.
        </p>
        <p className="text-xs text-muted-foreground mb-6">
          Puoi completare il pagamento sullo stesso ordine entro 15 minuti. Se nel frattempo
          modifichi il carrello, l&apos;ordine viene annullato e al prossimo pagamento ne viene creato uno nuovo.
        </p>

        <div className="mb-4 text-left empty:hidden"><PendingPaymentBanner /></div>

        <Link
          to="/area-clienti/checkout"
          className="h-10 px-5 rounded-lg bg-[hsl(214,58%,41%)] text-white text-sm font-medium inline-flex items-center gap-2"
          data-testid="payment-cancelled-back"
        >
          <ArrowLeft className="w-4 h-4" /> Torna al checkout
        </Link>

        {codTrans && (
          <div className="mt-6 text-[11px] text-muted-foreground">
            Riferimento: <span className="font-mono">{codTrans}</span>
          </div>
        )}
      </div>
    </div>
  );
}
